import React, { JSX } from 'react'
import { InputViewProps } from './useInput'
import styleInput from './Input.module.scss'

export const InputView = (props: InputViewProps): JSX.Element => {
  const {
    value,
    label,
    isFixed,
    type,
    reference,
    disabled,
    isFocus,
    setIsFocus,
    isDashed,
    classNameValueFocus,
    changeInput,
    isChecked,
    isMultiple,
    maxNumber,
    minNumber,
    stepNumber
  }: InputViewProps = props

  return (
    <div className={styleInput._field}>
      <div
        className={
          styleInput._field__box +
          ((!!classNameValueFocus(value, isFocus, isFixed) && ' ' +
            classNameValueFocus(value, isFocus, isFixed)) || '') +
          (isDashed ? ' ' + styleInput._field__box_dashed : '')
        }>
        <label>
          {label && (
            <span className={styleInput._field__label}>
              {label}
            </span>
          )}
          {!(type === 'file' || type === 'checkbox') && (
          <input
            className={styleInput._field__input}
            type={(!!type && type) || 'text'}
            defaultValue={(!!value && value) || undefined}
            autoComplete="off"
            disabled={disabled}
            ref={reference || undefined}
            onWheel={(event: React.WheelEvent<HTMLInputElement>) => { event.currentTarget.blur() }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeInput(event)
            }}
            onFocus={() => {
              setIsFocus(true)
            }}
            onBlur={() => {
              setIsFocus(false)
            }}
            max={maxNumber && maxNumber}
            min={minNumber && minNumber}
            step={stepNumber && stepNumber}
          />
          )}

          {type === 'checkbox' && (
          <input
            className={styleInput._field__input}
            type={(!!type && type) || 'text'}
            defaultValue={(!!value && value) || undefined}
            autoComplete="off"
            disabled={disabled}
            checked={isChecked}
            ref={reference || undefined}
            onWheel={(event: React.WheelEvent<HTMLInputElement>) => { event.currentTarget.blur() }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeInput(event)
            }}
            onFocus={() => {
              setIsFocus(true)
            }}
            onBlur={() => {
              setIsFocus(false)
            }}
          />
          )}

          {type === 'file' && (
          <input
            className={styleInput._field__input}
            type={(!!type && type) || 'text'}
            defaultValue={(!!value && value) || undefined}
            autoComplete="off"
            disabled={disabled}
            ref={reference || undefined}
            onWheel={(event: React.WheelEvent<HTMLInputElement>) => { event.currentTarget.blur() }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeInput(event)
            }}
            onFocus={() => {
              setIsFocus(true)
            }}
            onBlur={() => {
              setIsFocus(false)
            }}
            multiple={isMultiple}
          />
          )}
        </label>
      </div>
    </div>
  )
}
